import TourDataMapViewController from "./tour_data_map_view_controller"
import MapProtractor from "../admin_controllers/map_protractor"

export default class extends TourDataMapViewController {
    onPointsSimplifierLoad() {
        this.pointsSimplifier.on('pointMouseover', (event, record) => {
            this.mapProtractor = new MapProtractor(this.map, null, true, 1.0)
            this.mapProtractor.open(record.data.position, record.data.angle)
        })

        this.pointsSimplifier.on('pointMouseout', (event, record) => {
            if (this.mapProtractor) {
                this.mapProtractor.close()
            }
        })
    }
}